import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Form, FormGroup, Label, Input } from 'reactstrap';

const CloseCashierModal = ({ isOpen, toggle, onConfirm, isProcessing }) => {
    const [closingBalance, setClosingBalance] = useState(0);

    const handleSubmit = (e) => {
        e.preventDefault();
        onConfirm({ closingBalance: Number(closingBalance) });
    };

    // Reseta ao abrir
    React.useEffect(() => {
        if (isOpen) {
            setClosingBalance(0);
        }
    }, [isOpen]);

    return (
        <Modal isOpen={isOpen} toggle={toggle} centered backdrop="static" className="border-0 shadow">
            <ModalHeader toggle={toggle} className="border-bottom pb-3">
                <span className="fw-bold text-dark font-size-15">
                    <i className="mdi mdi-lock-outline text-danger me-2"></i>
                    Fechamento Cego de Caixa
                </span>
            </ModalHeader>
            <Form onSubmit={handleSubmit}>
                <ModalBody>
                    <div className="alert alert-warning px-3 py-2 mb-4 d-flex align-items-center">
                        <i className="mdi mdi-alert-outline font-size-22 me-2"></i>
                        <div>
                            <strong>Atenção!</strong> Conte as cédulas e moedas da sua gaveta com cuidado. O sistema calculará automaticamente as possíveis sobras ou quebras baseando-se nos lançamentos recebidos em dinheiro durante o seu turno.
                        </div>
                    </div>

                    <FormGroup className="mb-0 text-center">
                        <Label className="fw-bold mb-3 d-block text-muted">A CONTAGEM DA GAVETA</Label>
                        <Input
                            id="closing-balance-input"
                            name="closingBalance"
                            type="number"
                            className="form-control form-control-lg text-center fs-2 bg-light border-0 fw-bold text-danger py-4"
                            placeholder="0,00"
                            min="0"
                            step="0.01"
                            value={closingBalance}
                            onChange={(e) => setClosingBalance(e.target.value || 0)}
                            autoComplete="off"
                            required
                        />
                        <small className="text-muted d-block mt-3 px-4">
                            Informe apenas o <b>valor total físico</b> (em espécie) contido no caixa agora. Pagamentos eletrônicos (PIX, Cartão) são apurados automaticamente.
                        </small>
                    </FormGroup>
                </ModalBody>
                <ModalFooter className="border-top pt-3">
                    <Button color="light" className="text-muted fw-semibold" onClick={toggle} disabled={isProcessing}>
                        Revisar
                    </Button>
                    <Button color="danger" type="submit" disabled={isProcessing} className="fw-semibold px-4 shadow">
                        {isProcessing ? 'Encerrando...' : 'Confirmar Fecho'}
                    </Button>
                </ModalFooter>
            </Form>
        </Modal>
    );
};

export default CloseCashierModal;
